export default {
  DISTURBANCE_SOUND: 'disturbance sound', // เสียงแทรก
  ARRHYTHMIA: 'arrhythmia', // เต้นไม่เป็นจังหวะ
  ENLARGED_HEART: 'enlarged heart' // หัวใจโต
}
